.new-pill {
  display: inline-flex;
  align-items: center;

  height: 24px;
  min-width: 20px;
  padding: 0 var(--space-8);

  border-radius: var(--Radius-XL, var(--space-32));
  background: var(--Upgrade-Medium);

  color: var(--white);
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: var(--space-16);
}
